<template>
<div class="box-page">
    <div class="page-header with-underline">
        <div class="d-flex align-items-center justify-content-center">
            <span class="page-title">ตั้งค่ารูปภาพพื้นหลัง</span>
        </div>
    </div>
    <div class="container text-center">
        <div class="row">
            <div class="col-md-12">
                <div><label>รูป Background หน้า Landing</label></div>
                <div style="font-size:12px">(ขนาดที่แนะนำ 1557 x 1650 px)</div>
                <img :src="imgLanding" class="img-member mt-2 cursor-pointer" @click="openImg(imgLanding)">
                <input type="file" ref="fileImgLanding" @change="previewFiles($event, 'imgLanding')" :disabled="isUploading" accept="image/x-png,image/jpeg" style="display:none;">
                <div class="mt-2">
                    <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileImgLanding.click()">
                        <template v-if="isUploading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </template>
                        <template v-else>อัพโหลดรูป</template>
                    </label>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <div><label>รูป Background หน้า Login</label></div>
                <div style="font-size:12px">(ขนาดที่แนะนำ 750 x 533 px)</div>
                <img :src="imgLogin" class="img-member mt-2" @click="openImg(imgLogin)">
                <input type="file" ref="fileImgLogin" @change="previewFiles($event, 'imgLogin')" :disabled="isUploading" accept="image/x-png,image/jpeg" style="display:none;">
                <div class="mt-2">
                    <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileImgLogin.click()">
                        <template v-if="isUploading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </template>
                        <template v-else>อัพโหลดรูป</template>
                    </label>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <div><label>รูป Background หน้า Home</label></div>
                <div style="font-size:12px">(ขนาดที่แนะนำ 750 x 533 px)</div>
                <img :src="imgHome" class="img-member mt-2" @click="openImg(imgHome)">
                <input type="file" ref="fileImgHome" @change="previewFiles($event, 'imgHome')" :disabled="isUploading" accept="image/x-png,image/jpeg" style="display:none;">
                <div class="mt-2">
                    <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileImgHome.click()">
                        <template v-if="isUploading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </template>
                        <template v-else>อัพโหลดรูป</template>
                    </label>
                </div>
            </div>
        </div>

    </div>
    <div class="text-center mt-3">
        <button class="btn btn-small" @click="updateSettings" :disabled="disabledBtn">ยืนยัน</button>
        <button class="btn btn-small" @click="loadSettings" :disabled="disabledBtn">ย้อนกลับ</button>
    </div>
</div>
</template>

<script>
    import ShareFunction from '../../share-function';
    export default {
        data: function () {
            return {
                baseUrl: window.BASE_URL,
                disabledBtn: false,

                initSrcImage: '/goobank_assets/common/img/avatar.png',
                imgLanding: '',
                imgLogin: '',
                imgHome: '',
                isUploading: false,
            }
        },
        computed: {
        },
        mounted() {
            this.imgLanding = this.baseUrl + this.initSrcImage;
            this.imgLogin = this.baseUrl + this.initSrcImage;
            this.imgHome = this.baseUrl + this.initSrcImage;
        },
        created() {
            this.loadSettings();
        },
        computed: {
        },
        methods: {
            loadSettings(id) {
                axios.get(`${this.baseUrl}/admin/setting-background-picture/api/get`).then(({ data }) => {
                    if (data != null && data.data) {
                        this.imgLanding = this.baseUrl + data.data.background_image_landing;
                        this.imgLogin = this.baseUrl + data.data.background_image_login;
                        this.imgHome = this.baseUrl + data.data.background_image_home;
                    }
                });
            },
            updateSettings() {
                this.disabledBtn = true;
                axios.defaults.headers.common["X-CSRF-TOKEN"] = document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content");
                const fileImgLanding = this.$refs.fileImgLanding;
                const fileImgLogin = this.$refs.fileImgLogin;
                const fileImgHome = this.$refs.fileImgHome;

                var formData = new FormData();

                if (fileImgLanding && fileImgLanding.files.length > 0) {
                    formData.append('background_image_landing', fileImgLanding.files[0]);
                }
                if (fileImgLogin && fileImgLogin.files.length > 0) {
                    formData.append('background_image_login', fileImgLogin.files[0]);
                }
                if (fileImgHome && fileImgHome.files.length > 0) {
                    formData.append('background_image_home', fileImgHome.files[0]);
                }

                var config = {
                    onUploadProgress: function(progressEvent) {
                        var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                        console.log('percentCompleted', percentCompleted);
                    }
                };
                axios.post(
                    `${this.baseUrl}/admin/setting-background-picture/api/update`,
                    formData,
                    config,
                )
                .then(({data}) => {
                    if (data.success) {
                        alertbox('บันทึกสำเร็จ');
                        this.disabledBtn = false;
                        // this.hideEditDoc(true);
                    } else if (data.message) {
                        alertbox(data.message);
                    }
                });


                // const fileBookBank = this.$refs.fileBookBank;
                // const fileAvatar = this.$refs.fileAvatar;

                // this.disabledBtn = true;
                // const params = {
                //     data: []
                // };
                // const keyOfFee = Object.keys(this.fee);
                // keyOfFee.forEach(item => {
                //     params.data.push({
                //         code: this.fee[item].code,
                //         value: this.fee[item].value,
                //         percent_value: this.fee[item].percent_value,
                //         is_percent: this.fee[item].is_percent,
                //     });
                // });
                // $.confirmbox({
                //     title: 'ยืนยัน',
                //     msg: 'บันทึกข้อมูลใช่หรือไม่ ?',
                //     confirmEvent: () => {
                //         axios.post(`${this.baseUrl}/admin/setting-background-picture/api/update`, params).then(({ data }) => {
                //             if (data != null && data.success) {
                //                 alertbox('บันทึกสำเร็จ');
                //                 this.loadSettings();
                //             }
                //         });
                //     }
                // });
                // setTimeout(() => {
                //     this.disabledBtn = false;
                // }, 1000);




                // axios.defaults.headers.common["X-CSRF-TOKEN"] = document
                //     .querySelector('meta[name="csrf-token"]')
                //     .getAttribute("content");
                // const fileIdCard = this.$refs.fileIdCard;
                // const fileBookBank = this.$refs.fileBookBank;
                // const fileAvatar = this.$refs.fileAvatar;
                // const fileBankSlip = this.$refs.fileBankSlip;
                // const fileCorpCert = this.$refs.fileCorpCert;
                // const fileDocJur = this.$refs.fileDocJur;
                // var formData = new FormData();
                // formData.append('id', this.member.id);
                // formData.append('type', this.member.type);
                // if (fileIdCard && fileIdCard.files.length > 0) {
                //     formData.append('id_card', fileIdCard.files[0]);
                // }
                // if (fileBookBank && fileBookBank.files.length > 0) {
                //     formData.append('book_bank', fileBookBank.files[0]);
                // }
                // if (fileAvatar && fileAvatar.files.length > 0) {
                //     formData.append('avatar', fileAvatar.files[0]);
                // }
                // if (fileBankSlip && fileBankSlip.files.length > 0) {
                //     formData.append('bank_slip', fileBankSlip.files[0]);
                // }
                // if (fileCorpCert && fileCorpCert.files.length > 0) {
                //     formData.append('corp_cert', fileCorpCert.files[0]);
                // }
                // if (fileDocJur && fileDocJur.files.length > 0) {
                //     formData.append('doc_jur', fileDocJur.files[0]);
                // }
                // var config = {
                //     onUploadProgress: function(progressEvent) {
                //         var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                //         console.log('percentCompleted', percentCompleted);
                //     }
                // };
                // axios.post(
                //     `${this.baseUrl}/admin/api/upload-member-document`,
                //     formData,
                //     config,
                // )
                // .then(({data}) => {
                //     if (data.success) {
                //         alertbox('บันทึกสำเร็จ');
                //         this.hideEditDoc(true);
                //     } else if (data.message) {
                //         alertbox(data.message);
                //     }
                // });

            },
            previewFiles(ev, target) {
                var vm = this;
                var files = event.target.files;
                if (files && files[0]) {
                    if (files[0].type != 'image/png' && files[0].type != 'image/jpeg') {
                        window.alertbox('only jpg/jpeg file types are allowed', 'warning');
                        vm.resetAvatar(ev);
                        return;
                    }
                    var fileSize = files[0].size;
                    var mbMaxSize = 5 * (1024 * 1024);
                    if (fileSize > mbMaxSize) {
                        window.alertbox('Maximum allowed 5MB for uploaded files', 'warning');
                        vm.resetAvatar(ev);
                        return;
                    }
                    var reader = new FileReader();
                    vm.isUploading = true;
                    reader.onload = function(e) {
                        if (target == 'imgLanding') {
                            vm.imgLanding = e.target.result;
                        } else if (target == 'imgLogin') {
                            vm.imgLogin = e.target.result;
                        } else if (target == 'imgHome') {
                            vm.imgHome = e.target.result;
                        }
                        setTimeout(() => {
                            vm.isUploading = false;
                        }, 500);
                    }
                    reader.readAsDataURL(files[0]);
                }
            },
            openImg(src) {
                ShareFunction.openImg(src);
            },
        },
        props: {
        },
        components: {
        },
    }
</script>

<style lang="scss" scoped>
    .img-member {
        min-width: 800px;
        min-height: 800px;
        max-width: 800px;
        max-height: 800px;
    }

    .ele-textbox {
        width: 100px;
        .ele-textbox-input {
            padding-top: 0;
            text-align: right;
        }
    }
    .page-sub-header {
        position: relative;
        width: 100%;
        min-height: 1px;
        display: flex;
        justify-content: space-between;
    }
</style>



